import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Item = function Item(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("Grid");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "item"
    })
  }, children);
};

Item.displayName = "Grid.Item";
export default Item;